export default function useTagNumber(): string {
  const pkg = require('../../package.json')
  return pkg.version
}
